import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { BranchReview, BranchReviewConclusion } from 'types/branch_review'
import { mergeURL } from './lib'

const resource = 'branch_reviews'

type IndexParams = {
  page?: number
  order?: string
}

export const requests = {
  fetchIndex: async ({ page, order }: IndexParams) => {
    return await axiosForGigbaseBiz.get<DataResponse<BranchReview[]>>(
      resource,
      {
        params: {
          order,
          page,
        },
      },
    )
  },
  fetchConclusion: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<BranchReviewConclusion>>(
      mergeURL(resource, 'conclusion'),
    )
  },
}
